import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import { styled } from "styled-components";
import { PurchaseStore } from "../store";
import {
  CustomLabel,
  FlexContainer,
  IStyleProps,
  Loader,
} from "@mindmemobile/mm-shared-global";
import { CheckoutIframeWrapper, PurchaseWrapper } from "../styles";
import NavPills from "./NavPills";
import { IFRAMEMessageTypes } from "../enums";

type PreviewMode = "desktop" | "mobile";

type IProps = {
  purchaseStore: PurchaseStore;
};

export const IFrameWrapper = styled.div<IStyleProps>`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
  max-width: ${(props) => props.maxWidth || "100%"};

  iframe {
    border: none;
    width: 100%;
    height: 100%;
    transform-origin: top left;
    margin: 0 auto;
  }

  .desktop {
    width: 1250px;
    /* height: 1000px; */
  }

  .mobile {
    width: 600px;
    /* height: 800px; */
  }
  .preview-wrappper {
    padding: 30px;
    ${PurchaseWrapper} {
      padding: 25px 30px;
    }
  }
`;

const CheckoutIframeDetailPage: React.FC<IProps> = ({ purchaseStore }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  // const [zoom, setZoom] = useState(100);
  const [previewMode, setPreviewMode] = useState<PreviewMode>(
    window.innerWidth > 2330 ? "desktop" : "mobile"
  );
  // const [height, setHeight] = useState(previewMode === 'mobile' ? 800 : 1000);
  const [width, setWidth] = useState(previewMode === "mobile" ? 600 : 1250);
  const [messagePostedRecieved, setMessagePostedRecieved] = useState(false);
  useEffect(() => {
    const iframe = iframeRef.current;
    const sendMessage = () => {
      const message = {
        ...purchaseStore.toJSON(),
        type: IFRAMEMessageTypes.CheckOutDetailPreivewData,
      };
      iframe?.contentWindow?.postMessage(JSON.stringify(message), "*");
    };
    iframe?.removeEventListener("load", sendMessage);
    iframe?.addEventListener("load", sendMessage);
    window.addEventListener("message", handleMessageDataReceived);
    if (iframe?.contentWindow) {
      setTimeout(() => {
        sendMessage();
      }, 3000);
    }
    return () => {
      iframe?.removeEventListener("load", sendMessage);
      window.removeEventListener("message", handleMessageDataReceived);
    };
  }, [purchaseStore]);

  function handleMessageDataReceived(event: any) {
    if (!event?.data || typeof event?.data !== "string") return;
    try {
      const data = JSON.parse(event?.data);
      if (data?.type !== IFRAMEMessageTypes.PreviewMessageDataReceived) return;
      if (iframeRef?.current) {
        iframeRef.current.style.display = "block";
        setMessagePostedRecieved(true);
      }
    } catch (e) {}
  }

  useEffect(() => {
    function handleResize() {
      // const zoomLevel = (window.innerWidth / window.outerWidth) * 100;
      // setZoom(zoomLevel);
      // setHeight(window.innerHeight);
      setWidth(window.innerWidth);
      setPreviewMode(window.innerWidth > 2330 ? "desktop" : "mobile");
    }

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const togglePreviewMode = (mode: PreviewMode) => {
    setPreviewMode(mode);
  };

  return (
    <CheckoutIframeWrapper width="100%" className="iframe-detail-page">
      <FlexContainer fxLayout="column" alignItems="center" spacing={30}>
        <div>
          <NavPills
            defaultActiveKey={previewMode}
            activeKey={previewMode}
            pills={[
              {
                key: "desktop",
                title: "DESKTOP",
                isDisabled: window.innerWidth < 2330 ? true : false,
              },
              {
                key: "mobile",
                title: "MOBILE",
              },
            ]}
            onSelect={(key) => togglePreviewMode(key as PreviewMode)}
          />
        </div>
        <IFrameWrapper
          maxWidth={`${previewMode === "mobile" ? "650px" : "100%"} `}
        >
          {!messagePostedRecieved && new Loader(true).loaderComponent}
          <iframe
            src="/app/checkout/preview/detail"
            style={{ display: "none" }}
            ref={iframeRef}
            className={`${width > 2330 ? "desktop" : previewMode === "mobile" ? "mobile" : "desktop"}}`}
            height={"100%"}
            // style={{
            //     transform: `scale(${zoom / 100})`,
            //     transformOrigin: 'top left',
            // }}
            // style={{
            //     height: 1200 * (zoom / 100) - 32, // Subtract header height
            //     transform: `scale(${zoom / 100})`,
            //     transformOrigin: 'top left',
            // }}
          />
        </IFrameWrapper>
      </FlexContainer>
    </CheckoutIframeWrapper>
  );
};

export default observer(CheckoutIframeDetailPage);
